import { connect } from 'react-redux'
import { compose, withProps } from 'recompose'
import { getCurrentStorePhoneNumber } from 'selectors/getCurrentStore'
import { getCurrentStore } from 'selectors'
import { formatPhoneNumber } from 'helpers/phone-number'
import { showStoreLocatorModal } from 'actions/storeLocator'
import Details from './Details'
import { showNewShopTiresModal } from '../../../../NewShopTiresModal/actions'
import { GENERAL_SOURCE, YMME_NAME } from 'constant'

const mapStateToProps = state => ({
  storePhoneNumber: getCurrentStorePhoneNumber(state),
  formattedStorePhoneNumber: formatPhoneNumber(getCurrentStorePhoneNumber(state)),
  hasStore: getCurrentStore(state)
})

const withPriceInformation = withProps(({
  productPrice = '',
  hasStore,
  showNewShopTiresModal,
  itemMinPrice,
  itemMaxPrice
}) => ({
  isShowSelectStore: !hasStore,
  isShowPrice: hasStore && (itemMinPrice !== 0 && itemMaxPrice !== 0),
  isNoStoreShowPrice: !hasStore && (itemMinPrice !== 0 && itemMaxPrice !== 0),
  isShowCallStoreForPrice: hasStore && (itemMinPrice === 0 && itemMaxPrice === 0),
  addVehicle: () => showNewShopTiresModal({
    isOnlyVehicle: true,
    ymmeName: YMME_NAME,
    withShowConfirmTireSizeModal: true,
    source: GENERAL_SOURCE
  })
}))

export default compose(
  connect(mapStateToProps, { showStoreLocatorModal, showNewShopTiresModal }),
  withPriceInformation
)(Details)
